module.exports = __webpack_public_path__ + "img/typewriter-loading-image.05530092.svg";